import App from '@/app/App';
import '@/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

/** `yarn dev:mock` — 실제 API 대신 MSW 목 데이터로 화면을 띄운다 (계정 없이 확인용) */
const enableMocking = async () => {
  if (import.meta.env.VITE_API_MOCK !== 'true') return;
  const { worker } = await import('@/mocks/browser');
  // 서비스 워커를 못 쓰는 환경이면 목 없이 그대로 띄운다
  await worker
    .start({ onUnhandledRequest: 'bypass' })
    .catch((error) => console.warn('[mock] MSW 시작 실패', error));
};

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
